import authProvider from './auth_provider';
import dataProvider from './data_provider';
import LoginPage from './LoginPage';

export default {
	authProvider,
	dataProvider,
	LoginPage,
}